import WidgetRegisterForEventRequestModelBase from '../_generated/modelBases/widget-register-for-event-request-model-base';

export default class WidgetRegisterForEventRequestModel extends WidgetRegisterForEventRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
